import { LocaleImage } from '@/i18n/router';
import { useLocale } from '@/i18n/LocaleProvider';
import { Localize } from '@/i18n/Localize';
import { sharedPortuguese } from '@/i18n/shared';
import React, { useState } from 'react';
import { Play } from 'lucide-react';

interface LiteYouTubeProps {
  videoId: string;
  title: string;
  className?: string;
  start?: number;
}

const LiteYouTube: React.FC<LiteYouTubeProps> = ({
  videoId,
  title,
  className = "",
  start
}) => {
  const { locale } = useLocale();
  const [isLoaded, setIsLoaded] = useState(false);

  const handlePlay = () => {
    console.log('Playing video:', videoId);
    setIsLoaded(true);
  };

  if (isLoaded) {
    return <Localize messages={sharedPortuguese}>{(
      <div className={`relative w-full ${className}`} style={{ paddingBottom: '56.25%' }}>
        <iframe
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0${start ? `&start=${start}` : ''}`}
          title={title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          className="w-full h-full absolute top-0 left-0"
          loading="lazy"
        />
      </div>
    )}</Localize>;
  }

  return <Localize messages={sharedPortuguese}>{(
    <div 
      className={`relative cursor-pointer bg-black ${className}`}
      onClick={handlePlay}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handlePlay();
        }
      }}
      aria-label={`${locale === "pt-BR" ? "Reproduzir vídeo" : "Play video"}: ${title}`}
    >
      <LocaleImage
        src={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`}
        alt={title}
        width={1280}
        height={720}
        className="w-full h-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center hover:bg-opacity-20 transition-all duration-300">
        <div className="bg-red-600 rounded-full p-4 hover:bg-red-700 transition-colors">
          <Play className="h-8 w-8 text-white ml-1" fill="currentColor" />
        </div>
      </div>
    </div>
  )}</Localize>;
};

export default LiteYouTube;